import ApiBaseService from './ApiBaseService';

class PasswordService {
    // * Data - { email }
    static forgotPassword(data) {
        return ApiBaseService.request('/api/auth/forgotpwd', 'POST', data);
    }

    // * Data - { token }
    static passwordToken(data) {
        return ApiBaseService.request('/api/auth/pwdtoken', 'POST', data);
    }

    // * Data - { token, password }
    static resetPassword(data) {
        return ApiBaseService.request('/api/auth/resetpwd', 'POST', data);
    }
}

export default PasswordService;
